"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/objectDestructuringEmpty.js"));
require("core-js/modules/es6.regexp.split");
var _vue = _interopRequireDefault(require("vue"));
var _user = require("@/api/user");
var _firstLoginPassword = require("@/api/firstLoginPassword");
var _auth = require("@/utils/auth");
var _router = require("@/router");
var getDefaultState = function getDefaultState() {
  return {
    token: (0, _auth.getToken)(),
    name: '',
    avatar: '',
    deviceNameObj: {},
    deviceKeyObj: {},
    agentDevice: [],
    siteInfo: {},
    agentInfo: {},
    permissionInfo: {},
    /** 为 true 时全局拦截路由并弹出强制改密弹窗 */
    needForceChangePassword: false
  };
};
var state = getDefaultState();
var mutations = {
  RESET_STATE: function RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_LEVEL: function SET_LEVEL(state, level) {
    state.level = level;
  },
  SET_AGENT_DEVICE: function SET_AGENT_DEVICE(state, res) {
    state.deviceNameObj = res.deviceNameObj;
    state.deviceKeyObj = res.deviceKeyObj;
    state.agentDevice = res.agentDevice;
  },
  SET_SITEINFO: function SET_SITEINFO(state, res) {
    state.siteInfo = res;
  },
  SET_AGENTINFO: function SET_AGENTINFO(state, res) {
    state.agentInfo = res;
  },
  SET_PERMISSION: function SET_PERMISSION(state, res) {
    state.permissionInfo = res;
  },
  SET_NEED_FORCE_CHANGE_PASSWORD: function SET_NEED_FORCE_CHANGE_PASSWORD(state, flag) {
    state.needForceChangePassword = !!flag;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password,
      code = userInfo.code;
    // 从URL路径获取agent_id，如 /login/173
    var pathArr = window.location.pathname.split('/');
    var agentIdFromUrl = pathArr[pathArr.length - 1] || '';
    var isNumeric = /^\d+$/.test(agentIdFromUrl);
    var urlAgentId = isNumeric ? agentIdFromUrl : '';
    return new Promise(function (resolve, reject) {
      // 把 agent_id 加到 userInfo 里
      var loginData = {
        username: username.trim(),
        password: password,
        code: code,
        current_agent_id: urlAgentId
      };
      (0, _user.login)(loginData).then(function (data) {
        if (data.hasOwnProperty('permission')) {
          (0, _auth.setPermission)(data.permission.menus, 'server_permission_menus');
          (0, _auth.setPermission)(data.permission.roles, 'server_permission_roles');
        }
        commit('SET_TOKEN', data.token);
        (0, _auth.setToken)(data.token);
        (0, _auth.setToken)(data.user_id, 'user_id');
        if (data.is_qrcode == 1) {
          data.belong_partner_aid = 96;
        }
        (0, _auth.setToken)(data.belong_partner_aid || data.user_id, 'agent_id');
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 验证码登录 login
  codeLogin: function codeLogin(_ref2, formData) {
    var commit = _ref2.commit;
    var phone_num = formData.phone_num,
      captche_num = formData.captche_num;
    return new Promise(function (resolve, reject) {
      (0, _user.codeLogin)({
        phone_num: phone_num.trim(),
        captche_num: captche_num
      }).then(function (data) {
        commit('SET_TOKEN', data.token);
        (0, _auth.setToken)(data.token);
        (0, _auth.setToken)(data.user_id, 'user_id');
        (0, _auth.setToken)(data.belong_partner_aid || data.user_id, 'agent_id');
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)(state.token).then(function (data) {
        if (data.code > 0) {
          reject('验证失败，请重新登录。');
        }
        var role = ['terminal', 'partner', 'agent', 'director', 'salesman', 'merchants'];
        data.level_key = role[data['agent_level']];
        data.virtual_divide = 0;
        if (data.agent_level == 5) {
          var percent = {
            "0": "bao",
            "4": "wash",
            "1": "thread",
            "2": "massage",
            "3": "zhuang",
            "6": "blower",
            "7": "condom",
            "8": "humidifier",
            "12": "chazuo"
          };
          for (var i in percent) {
            if (data[percent[i] + '_virtual_divide'] == 1) {
              data.virtual_divide = 1;
              break;
            }
          }
        }
        window.agentInfo = data;
        var user_name = data.user_name,
          avatar = data.avatar,
          agent_level = data.agent_level;
        if (data.agent_level == 0) {
          var icon_link = document.createElement('link');
          icon_link.type = 'image/x-icon';
          icon_link.rel = 'shortcut icon';
          icon_link.href = data.avatar;
          document.getElementsByTagName('head')[0].appendChild(icon_link);
          document.title = "\u7BA1\u7406\u540E\u53F0-\u5171\u4EAB\u5145\u7535\u5B9D,\u5171\u4EAB\u6309\u6469\u6795,\u5171\u4EAB\u6D17\u8863\u673A,\u5145\u7535\u7EBF,\u5145\u7535\u5668-\u8D34\u724C\u4EE3\u7406\u52A0\u76DF\u7684\u5171\u4EABSaaS\u5E73\u53F0\u3002";
        }
        commit('SET_NAME', user_name);
        commit('SET_AVATAR', avatar);
        commit('SET_AGENTINFO', data);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get platform config
  getPlatformConfig: function getPlatformConfig(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve, reject) {
      (0, _user.getPlatformConfig)(params).then(function (data) {
        commit('SET_SITEINFO', data);
        if ((0, _auth.getToken)('user_id') == 97) {
          commit('SET_AGENTINFO', {});
          commit('SET_AGENT_DEVICE', {
            deviceNameObj: {},
            deviceKeyObj: {},
            agentDevice: {}
          });
        }
        if (data.mini_name) {
          var icon_link = document.createElement('link');
          icon_link.type = 'image/x-icon';
          icon_link.rel = 'shortcut icon';
          icon_link.href = data.mini_logo || data.mini_logo;
          document.getElementsByTagName('head')[0].appendChild(icon_link);
          document.title = "\u7BA1\u7406\u540E\u53F0-".concat(data.mini_name, ",\u5171\u4EAB\u5145\u7535\u5B9D,\u5171\u4EAB\u6309\u6469\u6795,\u5171\u4EAB\u6D17\u8863\u673A,\u5145\u7535\u7EBF,\u5145\u7535\u5668-\u8D34\u724C\u4EE3\u7406\u52A0\u76DF\u7684\u5171\u4EABSaaS\u5E73\u53F0\u3002");
        }
        _vue.default.prototype.SITE_INFO = data;
        window.siteInfo = data;
        resolve(data);
      });
    });
  },
  // user logout
  logout: function logout(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    return new Promise(function (resolve, reject) {
      (0, _auth.removeToken)(); // must remove  token  first
      (0, _auth.removeToken)('user_id');
      if ((0, _auth.getToken)('agent_id') == 1) (0, _auth.removeToken)('agent_id');
      (0, _router.resetRouter)();
      commit('RESET_STATE');
      resolve();
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      (0, _auth.removeToken)(); // must remove  token  first
      (0, _auth.removeToken)('user_id');
      commit('RESET_STATE');
      resolve();
    });
  },
  // 获取当前代理设备类型
  getDeviceType: function getDeviceType(_ref7) {
    var commit = _ref7.commit,
      state = _ref7.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getDeviceType)().then(function (res) {
        var deviceNameObj = {},
          deviceKeyObj = {},
          agentDevice = [];
        for (var i in res) {
          var d = res[i];
          if (d.taked > 0) {
            deviceNameObj[d.depend_name] = d.depend_type;
            agentDevice.push(d);
          }
          deviceKeyObj[d.depend_type] = d.depend_name;
        }
        window.deviceNameObj = deviceNameObj;
        commit('SET_AGENT_DEVICE', JSON.parse(JSON.stringify({
          deviceNameObj: deviceNameObj,
          deviceKeyObj: deviceKeyObj,
          agentDevice: agentDevice
        })));
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 提交操作记录
  postSetRecode: function postSetRecode(_ref8, tag_id) {
    (0, _objectDestructuringEmpty2.default)(_ref8);
    (0, _user.postSetRecode)({
      tag_id: tag_id
    });
  },
  /**
   * 是否需强制修改登录密码（PC）：need_force_password_pc 且未改密
   */
  checkFirstLoginPasswordStatus: function () {
    var _checkFirstLoginPasswordStatus = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref9) {
      var commit, data, need, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref9.commit;
            if (!((0, _auth.getToken)('user_id') == 97)) {
              _context.next = 1;
              break;
            }
            commit('SET_NEED_FORCE_CHANGE_PASSWORD', false);
            return _context.abrupt("return");
          case 1:
            _context.prev = 1;
            _context.next = 2;
            return (0, _firstLoginPassword.fetchFirstLoginPasswordStatus)();
          case 2:
            data = _context.sent;
            need = data && data.need_force_password_pc === true && data.has_password_updated === false;
            commit('SET_NEED_FORCE_CHANGE_PASSWORD', !!need);
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            commit('SET_NEED_FORCE_CHANGE_PASSWORD', false);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    function checkFirstLoginPasswordStatus(_x) {
      return _checkFirstLoginPasswordStatus.apply(this, arguments);
    }
    return checkFirstLoginPasswordStatus;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};